import {loadStripe} from '@stripe/stripe-js';
import {useQuery} from '@tanstack/react-query';

import {STRIPE_SCRIPT_SRC} from 'constants/checkout';
import {ENDPOINTS} from 'constants/endpoints';
import {PAYMENT_METHODS} from 'constants/paymentMethods';
import {useLoadScript} from 'hooks/useLoadScript/useLoadScript';
import {apiConfig, HTTP_REQUEST_HEADER, HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE} from 'libs/api/api';
import {logWithSentry} from 'libs/sentry/sentry';

/**
 * Create apple pay stripe instance
 */
export const useApplePayStripe = () => {
    const isScriptLoaded = useLoadScript(STRIPE_SCRIPT_SRC);

    const {data: paymentConfigs} = useQuery({
        queryFn: () =>
            apiConfig.instanceGusaBackend({
                headers: {
                    [HTTP_REQUEST_HEADER.CONTENT_TYPE]:
                        HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE.APPLICATION_JSON,
                },
                method: 'get',
                // TODO check why we use this EP for getting publishable_key, because we can take it from /payments here as well and do not make extra request
                url: `${ENDPOINTS.CART_GET_PAYMENT_BUTTONS}`,
            }),
        queryKey: [ENDPOINTS.CART_GET_PAYMENT_BUTTONS],
        refetchInterval: false,
        refetchIntervalInBackground: false,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
    });
    const stripeApplePayKey: string =
        paymentConfigs?.data[PAYMENT_METHODS.APPLEPAY_V2]?.publishable_key;

    const {data: stripe} = useQuery({
        enabled: Boolean(stripeApplePayKey) && isScriptLoaded,
        // next line has differences with host, pay attention if smt is wrong with stripe apple pay, but should work properly
        queryFn: () =>
            loadStripe(stripeApplePayKey).catch(e => {
                logWithSentry(e, 'Stripe script loading failed');
                return null;
            }),
        queryKey: [ENDPOINTS.CART_GET_PAYMENT_BUTTONS, stripeApplePayKey],
        refetchInterval: false,
        refetchIntervalInBackground: false,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
    });

    return stripe || null;
};
